<div class="contacts-container">
  <div class="controls-row">
    <button mat-raised-button color="primary" class="add-contact-btn" (click)="addContact()">
      <mat-icon>add</mat-icon>
      Add Contact
    </button>
    <span class="spacer"></span>
  </div>

  @if (loading()) {
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <div class="table-container">
      <h1>Contacts</h1>
      @if (dataSource().length === 0) {
        <div class="no-data">
          <p>No contacts found. Click "Add contact" to create one.</p>
        </div>
      } @else {
        <table mat-table [dataSource]="dataSource()" matSort class="contacts-table">
          <!-- Category Column -->
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
            <td mat-cell *matCellDef="let contact">{{contact.category}}</td>
          </ng-container>

          <!-- First Name Column -->
          <ng-container matColumnDef="first_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
            <td mat-cell *matCellDef="let contact">{{contact.first_name}}</td>
          </ng-container>

          <!-- First Name Column -->
          <ng-container matColumnDef="first_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
            <td mat-cell *matCellDef="let contact">{{contact.first_name}}</td>
          </ng-container>

          <!-- Last Name Column -->
          <ng-container matColumnDef="last_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
            <td mat-cell *matCellDef="let contact">{{contact.last_name}}</td>
          </ng-container>

          <!-- Organization Column -->
          <ng-container matColumnDef="organization">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
            <td mat-cell *matCellDef="let contact">{{contact.organization}}</td>
          </ng-container>

          <!-- Options Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let contact">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editContact(contact)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                <button mat-menu-item (click)="deleteContact(contact)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
    </div>
  }
</div>
